<template>
  <WCSinglePageForm>
    <template v-slot:title>
      {{ $t('signIn') }}
    </template>

    <template v-slot:title-right v-if="$configuration.allowCustomerAdd">
      <label>
        {{ $t('notSignedUpYet') }}
        <router-link class="font-weight-bold underline-link-from-center" to="/register">{{
          $t('createAccount')
        }}</router-link>
      </label>
    </template>

    <template v-slot:subheading>
      {{
        isCustomerModeScan
          ? $t('loginFormSubheadingAcceleratedCheckOut', { retailer: getStoreName })
          : $t('loginFormSubheading')
      }}
    </template>

    <template v-slot:body>
      <form @submit.prevent="submit">
        <WCFormGroup :field="$v.form.account">
          <label for="login-form__account"
            >{{ $t('emailPhoneOrAccountNumber') }}<span class="text-danger"> *</span></label
          >
          <WCValidatedInput
            id="login-form__account"
            v-model="form.account"
            :vuelidateObject="$v.form.account"
            autocomplete="section-login username"
            >{{ $t('fieldIsRequired') }}</WCValidatedInput
          >
          <WCValidationErrors />
        </WCFormGroup>
        <WCFormGroup :field="$v.form.password">
          <label for="login-form__password"
            >{{ $t('password') }}<span class="text-danger"> *</span></label
          >
          <WCPasswordInput
            id="login-form__password"
            v-model="form.password"
            :vuelidate-object="$v.form.password"
          />
          <WCValidationErrors />
        </WCFormGroup>
        <button class="btn btn-primary btn-block mb-3 submit-btn" :disabled="$v.form.$invalid">
          {{ $t('signIn') }}
        </button>
        <p class="text-center">
          {{ $t('forgotYourPassword') }}
          <router-link class="font-weight-bold underline-link-from-center" to="/forgot">{{
            $t('resetNow')
          }}</router-link>
        </p>
      </form>
    </template>
  </WCSinglePageForm>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCSinglePageForm from '@/modules/forms/components/WCSinglePageForm/WCSinglePageForm.vue';
import WCPasswordInput from '@/modules/forms/components/WCPasswordInput/WCPasswordInput.vue';
import WCValidatedInput from '@/modules/forms/components/WCValidatedInput/WCValidatedInput.vue';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';

export default {
  name: 'WCLoginForm',
  components: {
    WCValidatedInput,
    WCFormGroup,
    WCSinglePageForm,
    WCPasswordInput,
    WCValidationErrors,
  },
  data() {
    return {
      form: {
        account: '',
        password: '',
      },
      passwordHidden: true,
    };
  },
  props: {
    isCustomerModeScan: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    togglePasswordHidden() {
      this.passwordHidden = !this.passwordHidden;
    },
    submit() {
      this.$emit('submit', this.form);
    },
  },
  computed: {
    getStoreName() {
      return this.$configuration.store.name;
    },
    passwordInputType() {
      return this.passwordHidden ? 'password' : 'text';
    },
    passwordIcon() {
      return this.passwordHidden ? 'eye' : 'eye-slash';
    },
  },
  validations: {
    form: {
      account: {
        required,
      },
      password: {
        required,
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.login-form__password-wrapper {
  position: relative;
}

.login-form__show-password-icon {
  position: absolute;
  height: 100%;
  top: 0;
  right: rem(10px);
  cursor: pointer;
}
</style>
